<template>
  <div>
    <NBar title="近7天生日会员" :top="true"/>
    <nut-cell :show-icon="true" title="会员等级" @click.native="isVisible = true">
      <div slot="desc">
        <span style="color:rgb(0, 122, 255);">{{levelName}}</span>
      </div>
    </nut-cell>
    <nut-actionsheet :is-visible="isVisible" @close="isVisible = false">
      <div slot="custom">
        <div class="modal-header">
          <span class="btn" @click="isVisible = false">返回</span>
          <span class="text">请选择</span>
          <span class="btn" @click="ok()"> 确定</span>
        </div>
        <div class='level-item' v-for="(item,index) in list">
          <span class='title'>Lv{{index+1}}</span>
          <nut-radio v-model="levelNum" :label="index" @click="checkboxTap(index)"/>
        </div>
      </div>
    </nut-actionsheet>
    <nut-cell :show-icon="false">
      <div slot="title">
        <span style="color:#8e8e8e">{{levelName}}</span>
      </div>
    </nut-cell>
  </div>
</template>

<script>
export default {
  name: 'MemberBirthday',
  data () {
    return {
      list: [{
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }, {
        name: '测试',
        phone: '18507316674',
        provinceName: '广东',
        cityName: '深圳',
        areaName: '宝安区',
        address: '新港同创汇'
      }],
      page: 2,
      num: 5,
      isHasMore: true,
      isLoading: false,
      isErr: false,
      timer: null,
      //是否显示动作面板
      isVisible: false,
      //级别id
      levelNum: 0,
      //级别名称
      levelName: '全部',
    }
  },
  methods: {
    onInfinite () {
      this.isLoading = true
      this.timer = setTimeout(() => {
        if (this.page <= 5) {
          let list = [{
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }, {
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }, {
            name: '测试',
            phone: '18507316674',
            provinceName: '广东',
            cityName: '深圳',
            areaName: '宝安区',
            address: '新港同创汇'
          }]
          for (let i in list) {
            this.list.push(list[i])
          }
          this.page = this.page + 1
        } else {
          this.isHasMore = false
        }
        this.isLoading = false
      }, 100)
    },
    //下单类型选择
    checkboxTap (value) {
      console.log(value)
      this.levelNum = value + 1
    },
    ok () {
      this.levelName = 'Lv' + this.levelNum
      this.isVisible = false
    }
  }
}
</script>

<style scoped>
  .modal-header {
    height: 50px;
    padding: 0 10px;
    line-height: 50px;
    background: #fff;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .modal-header .btn {
    color: #1a87ff;
  }

  .level-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    background: #ffffff;
    height: 40px;
    border-bottom: 1px #f9f9fb solid;
  }
  >>> .nut-radio input:checked {
    background-color: #007aff;
    border-color: #007aff;
  }

  >>> .nut-radio input:after {
    background: #007aff;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/member/MemberBirthday.vue